import { useMutation, useQuery } from "@tanstack/react-query";
import { fetch3, fetch4, fetch5 } from "../commonApis/commonApis";
import toast from "react-hot-toast";

const url = process.env.REACT_APP_BASE_URL;

export const useFetchJtCredentials = (clientId: string) => {
  return useQuery({
    queryKey: ["jtCredentials", clientId],
    queryFn: async () => {
      if (!clientId) return null;
      const res = await fetch3(`${url}/api/jt/credentials?clientId=${clientId}`, "get");
      return res?.data || null;
    },
    enabled: !!clientId,
  });
};

export const useEditJtCredentialsMutation = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const res = await fetch4(`${url}/api/jt/connect`, payload);
      if (!res?.success) throw new Error(res?.message || "Failed to connect J&T Express");
      return res.data;
    },
    onSuccess: (data: any) => {
      toast.success(data?.message || "J&T Express connected successfully");
    },
    onError: (err: any) => {
      toast.error(err?.message || "Failed to connect J&T Express");
    },
  });
};

export const useJtBulkForwardMutation = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const res = await fetch5(`${url}/api/bulk/jt-bulk-forward`, "POST", payload);
      if (!res?.success) throw new Error(res?.message || "Failed to enqueue bulk forward");
      return res.data;
    },
    onSuccess: (data: any) => {
      toast.success(data?.message || "Bulk forward job queued successfully");
    },
    onError: (err: any) => {
      toast.error(err?.message || "Failed to enqueue bulk forward");
    },
  });
};

export const useJtBulkLabelPrintMutation = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const res = await fetch5(`${url}/api/bulk/jt-bulk-label-print`, "POST", payload);
      if (!res?.success) throw new Error(res?.message || "Failed to enqueue label printing");
      return res.data;
    },
    onSuccess: (data: any) => {
      toast.success(data?.message || "Bulk label print job queued successfully");
    },
    onError: (err: any) => {
      toast.error(err?.message || "Failed to enqueue label printing");
    },
  });
};

export const useJtJobStatus = (jobId?: string) => {
  return useQuery({
    queryKey: ["jtJobStatus", jobId],
    queryFn: async () => {
      const res = await fetch3(`${url}/api/bulk/jobs/${jobId}`, "get");
      if (!res?.data) return null;
      return res.data;
    },
    enabled: !!jobId,
    refetchInterval: (data: any) => {
      if (data?.status === "COMPLETED" || data?.status === "FAILED") return false;
      return 3000;
    },
    staleTime: 0,
  });
};

export const useTrackJtShipment = () => {
  return useMutation({
    mutationFn: async (payload: { awbNo: string; clientId: string }) => {
      const res = await fetch4(`${url}/api/jt/track`, payload);
      if (!res?.success) throw new Error(res?.message || "Tracking failed");
      return res.data;
    },
  });
};

export const useCheckJtOrderMutation = () => {
  return useMutation({
    mutationFn: async (payload: { serialNumbers: string[]; clientId: string }) => {
      const res = await fetch4(`${url}/api/jt/check`, payload);
      if (!res?.success) throw new Error(res?.message || "Check order failed");
      return res.data;
    },
  });
};

export const useCancelJtOrderMutation = () => {
  return useMutation({
    mutationFn: async (payload: { txlogisticId: string; reason?: string; clientId: string }) => {
      const res = await fetch4(`${url}/api/jt/cancel`, payload);
      if (!res?.success) throw new Error(res?.message || "Cancel order failed");
      return res.data;
    },
  });
};
